export const API_URL = "https://efito.uz";
export const API_VPN_URL = "http://10.0.229.30:30080/";
export const BASE_URL = `${API_URL}/`;

export const AGRO_URL = "https://efito.uz/";
export const AGRO_URL_NEW = "https://akk.karantin.uz/api/v2/";
// export const AGRO_URL = "http://195.158.24.122:8002/api/v2/";
export const REG_URL = "https://reg.efito.uz/api/v1/";
export const REG_TOKEN = "9ce938025d8cf48baee9eb6473ab90c60ec8ff4e";
